import { render, staticRenderFns } from "./seckillList.vue?vue&type=template&id=970fabf8&"
import script from "./seckillList.vue?vue&type=script&lang=js&"
export * from "./seckillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports